// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__7SONQ","checkboxCol":"Table_checkboxCol__3GHaQ","emailCol":"Table_emailCol__1p9qT","actionCol":"Table_actionCol__1e1Wa"};